"use client";

import Link_ from "next/link";
import { type LinkProps } from "./types";
import { forwardRef } from "react";

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ smoothScrollTo, ...props }, ref) => {
    return (
      <Link_
        {...props}
        ref={ref}
        onClick={
          smoothScrollTo
            ? (e) => {
                e.preventDefault();
                const target = document.querySelector(smoothScrollTo);
                if (target) {
                  target.scrollIntoView({ behavior: "smooth" });
                }

                if (props.onClick) {
                  props.onClick(e);
                }
              }
            : props.onClick
        }
      />
    );
  },
);

Link.displayName = "Link";

export default Link;
